import { makePaginatedSearch } from "api/makeApiRequestType/makePaginatedSearch";

import { convertEventDatesToJavascriptDates } from "api/utils/convertEventDatesToJavascriptDates";
import { convertMeetingRescheduleRequestDatesToJavascriptDates } from "api/utils/convertMeetingRescheduleRequestDatesToJavascriptDates";
import { formatDataForGetRequest } from "api/utils/formatDataForGetRequest";
import { ValidationCallback } from "validation/validate";
import {
	RequestToMentorRawFromApi,
	flagValidationErrorsInRequestToMentorRawFromApi
} from "types-and-validators/RequestToMentorRawFromApi";

type RawApiOutputRow = {
	id: string;
	meetingId: string;
	reschedulerUid: string;
	dateStartsUTC: string;
	originalDateStartsUTC: string;
	dateEndsJustBeforeUTC: string;
	originalDateEndsJustBeforeUTC: string;
	privateMessageContents?: string;
	privateMessageDatesentUTC?: string;
	privateMessageId?: string;
} & RequestToMentorRawFromApi;

const flagValidationErrorsInRow: ValidationCallback<RawApiOutputRow> = (
	input,
	utils,
	auth
) => {
	const { checkField } = utils;

	checkField("id", { type: "string" });
	checkField("meetingId", { type: "string" });
	checkField("reschedulerUid", { type: "string" });
	checkField("dateStartsUTC", { type: "datestring" });
	checkField("dateEndsJustBeforeUTC", { type: "datestring" });
	checkField("originalDateStartsUTC", { type: "datestring" });
	checkField("originalDateEndsJustBeforeUTC", { type: "datestring" });

	flagValidationErrorsInRequestToMentorRawFromApi(input, utils, auth);
};

export interface OutputRow
	extends Omit<
		RawApiOutputRow,
		| "dateStartsUTC"
		| "dateEndsJustBeforeUTC"
		| "originalDateStartsUTC"
		| "originalDateEndsJustBeforeUTC"
		| "privateMessageDatesentUTC"
	> {
	dateStartsUTC: Date;
	dateEndsJustBeforeUTC: Date;
	originalDateStartsUTC: Date;
	originalDateEndsJustBeforeUTC: Date;
	privateMessageDatesentUTC?: Date;
}

type Params = {
	hostUid?: string;
	guestUid?: string;
	earliestStartDateUTC: Date;
	mustEndBeforeUTC?: Date;
	isAccepted?: boolean;
	isRejected?: boolean;
};

export const getMeetingRescheduleRequests = makePaginatedSearch<
	Params,
	RawApiOutputRow,
	OutputRow
>({
	endPoint: "meetingRescheduleRequests",
	flagValidationErrorsInRow,
	postProcessor: (response, requestPayload) => {
		const {
			dateStartsUTC,
			dateEndsJustBeforeUTC,
			privateMessageDatesentUTC,
			originalDateStartsUTC,
			originalDateEndsJustBeforeUTC,
			...rest
		} = response;

		return {
			...rest,
			...convertEventDatesToJavascriptDates({
				dateStartsUTC,
				dateEndsJustBeforeUTC,
				privateMessageDatesentUTC
			}),
			...convertMeetingRescheduleRequestDatesToJavascriptDates({
				originalDateStartsUTC,
				originalDateEndsJustBeforeUTC
			})
		};
	},
	preProcessor: formatDataForGetRequest
});
